import { HouseHoldSummary } from './wp-et-enrollment-household-summary.model';

export class HouseholdSummaryResponse {
  constructor(
          public wpEtEnrollmentHouseHoldSummaryList?: HouseHoldSummary[],
    ) {
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/model/household-summary-response.model.ts